import VivoEnterCredential from './Vivo/VivoEnterCredential';
import VivoEnterPin from './Vivo/VivoEnterPin';
import EnterZipCodeToPay from './Payment/EnterZipCodeToPay';
import Confirm from './Shared/Confirm';
import VivoError from './Vivo/VivoError';

const VivoComponents = {
    EnterCredential: VivoEnterCredential, 
    EnterPin: VivoEnterPin,   
    EnterZipCodeToPay: EnterZipCodeToPay,
    Confirm,
    Error: VivoError
};

export default VivoComponents;


/** WEBPACK FOOTER **
 ** ./src/components/ScreenComponents/VivoComponents.js
 **/